// extracted by mini-css-extract-plugin
export default {"skeletonContainer":"TemplateList-module__skeletonContainer__Gf5HPmF","templateHeader":"TemplateList-module__templateHeader__VBwsSpB"};